module.exports = __webpack_public_path__ + "static/media/testfile_adaptiveprofiles.271ccb26.zip";